import { ResponsePostMerchflowParseVariantRestrictions } from "@CommonApi/merchflow/parse-variant-restrictions";
import { z } from "zod";

/**
 * Client-side guard for the model's response. A malformed or partially-hallucinated
 * payload degrades to "couldn't read that — edit manually" instead of writing bad
 * data into the planogram. Rows that fail validation are dropped, not coerced.
 */
export const variantRestrictionConditionSchema = z.enum([
  "MUST_HAVE",
  "CAN_HAVE",
  "MUST_HAVE_ONLY",
  "MUST_NOT_HAVE",
]);

export const parsedVariantRestrictionRuleSchema = z.object({
  variant: z.string().min(1),
  matched: z.boolean(),
  confidence: z.number().min(0).max(100),
  suggestion: z.string().optional(),
  bay_number_rule: z.string(),
  shelf_rule: z.string(),
  condition: variantRestrictionConditionSchema,
});

export const storeFilterSchema = z.object({
  bay_sizes: z.array(z.number()),
  states: z.array(z.string()),
  clusters: z.array(z.string()),
  section_heights: z.array(z.number()),
  section_widths: z.array(z.number()),
});

const emptyStoreFilter = {
  bay_sizes: [],
  states: [],
  clusters: [],
  section_heights: [],
  section_widths: [],
};

export const parsedVariantRestrictionGroupSchema = z.object({
  store_codes: z.array(z.string()),
  unmatched_stores: z.array(z.string()),
  store_filter: storeFilterSchema.optional().default(emptyStoreFilter),
  target_group_name: z.string().nullable().optional(),
  rules: z.array(parsedVariantRestrictionRuleSchema),
});

export const parseVariantRestrictionsResponseSchema = z.object({
  groups: z.array(parsedVariantRestrictionGroupSchema),
});

export const safeParseGroups = (response: ResponsePostMerchflowParseVariantRestrictions | null) => {
  const result = parseVariantRestrictionsResponseSchema.safeParse(response);
  return result.success ? result.data.groups : null;
};
